import axios from "axios";

/**
 * GET /secrets?secretName=&vaultName= — proxy endpoint, auth-gated, returns
 * the raw secret value as the response body. Vault defaults to
 * VITE_VAULT_NAME (wig-dev-kv).
 *
 * NOTE: This service deliberately does NOT use the shared axiosInstance
 * because that instance is scoped to `baseURL: "/api"`. The proxy's
 * /secrets route sits at the top level (see wig-react-proxy/server.js and
 * nginx.conf), so we use a raw axios GET against a root-relative path.
 */
const secretsService = {
  getSecret: async (token, secretName, vaultName) => {
    const vault =
      vaultName || import.meta.env.VITE_VAULT_NAME || "wig-dev-kv";
    if (!token) throw new Error("Token required to fetch secret");
    const resp = await axios.get("/secrets", {
      params: { secretName, vaultName: vault },
      headers: { Authorization: `Bearer ${token}` },
    });
    return resp.data;
  },
};

export default secretsService;
